jQuery(($) => {
    if ($('button.a-toggle-button')[0]) {
        $('button.a-toggle-button').click(function () {
            $(this).toggleClass('a-toggle-button--toggled');
        });
    }
});